<div *ngIf="license" [class]="'status-pill ' + getStatusStyle(license.status, 'status-')">
  <label>{{ license.status | licenseStatus }}</label>
  <label [class]="'status-word ' + getStatusStyle(license.status, 'status-')"> #{{ license.number }} </label>
</div>
